type ApiFailure = {
  code?: string;
  config?: { url?: string; timeout?: number; method?: string };
  response?: { status: number; data?: any };
};

export function getApiFailureMessage(error: ApiFailure, online = navigator.onLine): string {
  const status = error.response?.status;
  const data = error.response?.data;
  const url = error.config?.url ?? '';
  const introduction = /\/introduce\/insert(?:[?#]|$)/i.test(url);
  const operation = introduction ? 'ارسال معرفی‌نامه' : /\/user\/info(?:[?#]|$)/i.test(url)
    ? 'دریافت اطلاعات کاربر' : 'درخواست';
  const uncertain = introduction ? ' نتیجه ثبت معرفی‌نامه مشخص نیست؛ پیش از ارسال دوباره، وضعیت و کد رهگیری حواله را بررسی کنید.' : '';
  // Only a response actually received from our API can identify an RMTO failure.
  const serverMessage = [data?.error, data?.message].find(value =>
    typeof value === 'string' && /[\u0600-\u06ff]/.test(value) && !/<[^>]+>/.test(value));
  if (serverMessage) return `${serverMessage}${status ? ` (کد ${status})` : ''}`;

  if (status) {
    const reasons: Record<number, string> = {
      408: 'سرور در مهلت تعیین‌شده درخواست را دریافت نکرد.',
      429: 'تعداد درخواست‌ها بیش از حد مجاز است؛ کمی صبر کنید.',
      500: 'خطای داخلی سرور بارنامه‌گرام رخ داده است.',
      502: 'درگاه سرور پاسخ معتبری از سرویس پشت آن دریافت نکرد.',
      503: 'سرویس موقتاً در دسترس نیست.',
      504: 'مهلت انتظار درگاه برای پاسخ سرویس پشت آن تمام شد.',
    };
    return `${operation}: ${reasons[status] ?? 'سرور درخواست را با خطا پاسخ داد.'} (کد ${status})${uncertain}`;
  }
  if (!online) return `${operation}: مرورگر اتصال اینترنت را قطع گزارش می‌کند.${uncertain}`;
  if (['ECONNABORTED', 'ETIMEDOUT'].includes(error.code ?? '')) {
    const seconds = error.config?.timeout ? ` پس از ${error.config.timeout / 1000} ثانیه` : '';
    return `${operation}: مهلت انتظار مرورگر${seconds} تمام شد؛ پاسخی از سرور بارنامه‌گرام دریافت نشد.${uncertain}`;
  }
  return `${operation}: مرورگر به پاسخ سرور دسترسی پیدا نکرد؛ ممکن است اتصال قطع شده یا پاسخ توسط مرورگر مسدود شده باشد. علت دقیق از این خطا قابل تشخیص نیست.${uncertain}`;
}
